<template>
    <div>
        <p>
            Сперва бабушка перечисляет пустые банки. Заводим пустые банки с
            определенным объемом и номером. Например банка с номером М85 объемом
            500 грамм.
        </p>
        <p>
            Далее она варит разное варенье - клубничное, вишневое, абрикосовое.
            Для каждого вида у нее своя кастрюля с произвольным объемом.
        </p>
        <p>
            Она указывает в системе что сварила 5000 грамм клубничного, и
            система находит пустые банки в которые можно залить варенье, и
            распределяет варенье по ним. И показывает результат - например что в
            банке М85 500 грамм клубничного варенья, а в банке М74 300 грамм
            вишневого.
        </p>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>
